// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsThemesAddTemplate_heading__E8jy0","buttonLink":"ReportingDetailsThemesAddTemplate_buttonLink__hRSPu"};